import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "pt-3 pb-0 px-0"
};
const _hoisted_2 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_3 = { class: "require-field-wrapper pb-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_v_select = _resolveComponent("v-select");
    const _component_v_card = _resolveComponent("v-card");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.dialog) = $event)),
        "content-class": "responsive-dialog",
        "onClick:outside": _ctx.handleClickCloseChangePickupExpectedAt,
        onKeydown: _withKeys(_ctx.handleClickCloseChangePickupExpectedAt, ["esc"])
    }, {
        activator: _withCtx(({ props }) => [
            (_ctx.isChangePickupExpectedAvailable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                        variant: "outlined",
                        class: "btn-outlined-basic",
                        width: "100%",
                        height: "40"
                    }), {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'change_pickup_expected_at')), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_DialogHeader, {
                        title: _ctx.$t(`${_ctx.lc}pickup_expected_at_dialog_title`),
                        "on-cancel": _ctx.handleClickCloseChangePickupExpectedAt
                    }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                    _createVNode(_component_v_card, {
                        flat: "",
                        tile: "",
                        class: "grey lighten-4"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, [
                                _createCommentVNode(" 변경 전 "),
                                _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.before_change')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createCommentVNode(" 예: hh시 mm분 [h시간 m분 지연/남음]  "),
                                _createVNode(_component_v_card_title, { class: "text-body-1 pt-2" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.order.pickupExpectedAt, _ctx.dateFormatType.STANDARD_TIME)) + " [" + _toDisplayString(_ctx.order.pickupExpectedAtRemainingTimeSuffix) + "] ", 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createCommentVNode(" 변경 후 "),
                                    _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.after_change')), 1 /* TEXT */),
                                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                        ]),
                                        _: 1 /* STABLE */,
                                        __: [3]
                                    }),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.addMinuteAmount,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.addMinuteAmount) = $event)),
                                        density: "compact",
                                        variant: "outlined",
                                        dense: "",
                                        "hide-details": true,
                                        inputmode: "numeric",
                                        class: "px-4 pt-2",
                                        placeholder: _ctx.$t(`${_ctx.lc}after_time_text_field_placeholder`),
                                        suffix: _ctx.$t(`${_ctx.lc}notice_pickup_expected_at_dialog`),
                                        oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                        onBlur: _ctx.checkIsUndefined,
                                        onKeyup: _ctx.checkIsValidNumber,
                                        onKeydown: _ctx.checkIsDoubleZero
                                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "suffix", "onBlur", "onKeyup", "onKeydown"]),
                                    _createCommentVNode(" 예: hh시 mm분 [h시간 m분 지연/남음]  "),
                                    _createVNode(_component_v_card_title, { class: "caption-normal-text text-red-darken-1 pt-2 pb-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.newPickupExpectedAtStandardTime) + " [" + _toDisplayString(_ctx.newPickupExpectedAtRemainingTimeSuffix) + "] ", 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createCommentVNode(" 요청자 "),
                                    _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}requestor`)), 1 /* TEXT */),
                                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                        ]),
                                        _: 1 /* STABLE */,
                                        __: [4]
                                    }),
                                    _createVNode(_component_v_select, {
                                        "item-title": "text",
                                        "item-value": "value",
                                        modelValue: _ctx.requestorOption,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.requestorOption) = $event)),
                                        items: _ctx.requestorOptionItems,
                                        "hide-details": "",
                                        density: "compact",
                                        variant: "outlined",
                                        dense: "",
                                        class: "px-4 pt-2"
                                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                                ])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_DialogFooter, {
                        cancel: true,
                        ok: true,
                        "on-cancel": _ctx.handleClickCloseChangePickupExpectedAt,
                        "on-ok": _ctx.handleClickOkChangePickupExpectedAt
                    }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]));
}
